import axios from "axios";

export default class Api {
  _baseUrl = "";

  _get = {
    method: "get",
    url: undefined,
    withCredentials: true,
    data: undefined
  };
  _download = {
    method: "get",
    url: undefined,
    withCredentials: true,
    data: undefined,
    responseType: "arraybuffer"
  };
  _post = {
    method: "post",
    url: undefined,
    withCredentials: true,
    data: undefined
  };
  _put = {
    method: "put",
    url: undefined,
    withCredentials: true,
    data: undefined
  };
  _patch = {
    method: "patch",
    url: undefined,
    withCredentials: true,
    data: undefined
  };
  _delete = {
    method: "delete",
    url: undefined,
    withCredentials: true,
    data: undefined
  };

  static request (type, apiUrl, data, onSuccess, onError) {
    const api = new Api();
    let t = undefined;

    switch (type) {
      case "get": t = api._get; break;
      case "put": t = api._put; break;
      case "patch": t = api._patch; break;
      case "delete": t = api._delete; break;
      case "download": t = api._download; break;
      default: t = api._post; break;
    }

    t.url = `${api._baseUrl}${apiUrl}`;
    t.data = data;

    axios(t).then(onSuccess).catch(onError);
  }
}
